export default "__VITE_ASSET__CuJ21MzJ__"